// extracted by mini-css-extract-plugin
module.exports = {"beta":"BetaTag_beta__3YvgD"};